import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { callGetCollectionContracts } from '@app/client/resources/marketplace';
type UseCollectionContractsProps = {
    slug?: string;
    disabled?: boolean;
};

export const useCollectionContracts = ({ slug, disabled }: UseCollectionContractsProps) => {
    const collectionSlug = slug || '';
    const cache = ['collection-daas-contracts', collectionSlug];

    return useQuery({
        queryKey: cache,
        queryFn: ({ signal }) =>
            callGetCollectionContracts({
                slug: collectionSlug,
                settings: {
                    signal,
                },
            }),
        retry: true,
        placeholderData: keepPreviousData,
        enabled: Boolean(collectionSlug) && !disabled,
    });
};
